import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { MediaMatcher } from '@angular/cdk/layout';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { GoogleMap, MapInfoWindow } from '@angular/google-maps';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HelperService } from '../helper.service';
import { Farm } from '../models/farm';
import { Field } from '../models/field';
import { FieldLegend } from '../models/fieldLegend';
import { History } from '../models/history';
import { RainMeters } from '../models/rainMeters';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import _moment, { default as _rollupMoment } from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { Countries } from '../models/countries';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FarmManagementService } from '../services/farm-management.service';
import { AnalysisManagementService } from '../services/analysis-management.service';
import { MappingService } from '../services/mapping.service';
import { RainfallService } from '../services/rainfall.service';
import { BoundaryManagementService } from '../services/boundary-management.service';
import { Base } from '../services/base';
import { MapsFarmImageryDto } from '../dto/MapsFarmImageryDto';
import { FarmLegend } from '../models/farmLegend';
import { MapsTypesAvailabilityModel } from '../models/mapsTypesAvailabilityModel';
import { SelectedFarmMapsItemModel } from '../models/selectedFarmMapsItemModel';
import { PinManagerService } from '../services/pin-manager.service';
import { Pin } from '../models/pin';
import { PinType } from '../models/pinType';
import { DynamicPin } from '../models/dynamicPin';
import { NewPin } from '../models/NewPin ';
import { Title } from "@angular/platform-browser";
import { TenantViewBoundingBox } from '../models/tenant-view-models/tenantViewBoundingBox';
import { TenantViewModel } from '../models/tenant-view-models/tenant-view-model';
import { TenantService } from '../services/tenant.service';
import { TenantFarmBoundsService } from './tenant-view-services/tenant-farm-bounds.service';
import { environment } from 'src/environments/environment';
import { GriddingStatusService } from './tenant-view-services/gridding-status.service';
import { GriddingComponent } from '../gridding/gridding.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { WeatherForecastComponent } from '../weather-forecast/weather-forecast.component';
import { WeatherForecastService } from '../weather-forecast/weather-forecast.service';
import { DayForecast } from '../weather-forecast/models';
import { FeatureFlagsService } from '../unleash-feature-flags/feature-flags.service';

declare var google: any;

const moment = _rollupMoment || _moment;

@Component({
    selector: 'app-tenant-view',
    templateUrl: './tenant-view.component.html',
    styleUrls: ['./tenant-view.component.css'],
    encapsulation: ViewEncapsulation.Emulated,
    animations: [
        trigger('slideInOut', [
            state('in', style({ 'opacity': '1', 'flex': '1 1 100%' }), { params: { inWidth: '250px' } }),
            state('out', style({ width: '15px', 'opacity': '1', 'flex': '1 1 1%' })),
            transition('in => out', [group([
                    animate('100ms ease-in-out', style({
                        'opacity': '1'
                    })),
                    animate('100ms ease-in-out', style({
                        width: '{{ inWidth }}px'
                    })),
                    animate('100ms ease-in-out', style({
                        'flex': '1 1 100%'
                    }))
                ])]),
            transition('out => in', [
                animate('100ms ease-in-out', style({
                    'opacity': '1'
                })),
                animate('100ms ease-in-out', style({
                    width: '15px'
                })),
                animate('100ms ease-in-out', style({
                    'flex': '1 1 1%'
                }))
            ])
        ]),
        trigger('rotate', [
            state('in', style({ transform: 'rotate(0deg)' })),
            state('out', style({ transform: 'rotate(180deg)' })),
            transition('in => out', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(0deg)'
                }))
            ]),
            transition('out => in', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(180deg)'
                }))
            ])
        ])
    ],
    standalone: false
})

export class TenantViewComponent implements OnInit, AfterViewInit {

    @ViewChild('selectFarm', { static: false }) selectFarm: ElementRef;

    @ViewChild('map') agmMap: GoogleMap;
    private currentInfoWindow: google.maps.InfoWindow | null = null;

    @ViewChild('buttonRef', { read: ElementRef }) public buttonRef: ElementRef<any>;
    @ViewChild('popUpElement', { read: ElementRef }) popUpElement: ElementRef;

    isWeatherForecastEnabled: boolean = false;
    
    polygonString: string = '';

    tenantPolygons: any;
    tenantFarms: TenantViewModel;
    tenantFields: TenantViewBoundingBox;
    tenantFarmFields: TenantViewModel;


    polygonHoverColor: string = environment.google.mapConfig.polygonHoverColor;
    savedPinStartDate = '';
    savedPinEndDate = '';

    farmOptionsStyle = {
        showOptions: false,
        optionsStyle: {}
    };
    renderer: Renderer2;

    mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;

    title: string = 'AGM project';

    latitude: number = -13.960981;
    longitude: number = 22.804752;

    pinMarkers = [];
    tmpMarkers = [];
    isPinsShowing = false;
    newSavedPinsData: Pin[];
    newSavedPins = [];
    selectedPinType: PinType;
    savedPinsDataCounter = 0;
    pinCounter = 1;
    tmpId = 0;
    tmpPins: Pin[] = [];
    tmpData: DynamicPin[] = [];
    barChartData: DynamicPin[] = [];

    existingPin: NewPin;
    existingMarker = null;

    previousValue: any;

    markers = [];
    centerMarkers = [];
    currentMarkers = [];
    substrings = ['CHEMICAL', 'NI'];

    analysisTypeAvailable: any;

    public zoom = 10;
    public maxMapZoom: number = 4;
    public minMapZoom: number = 10;

    public showTracking: boolean = true;
    public showOverlay: boolean = false;
    public showFields: boolean = true;
    public checkCircle: boolean = false;
    public isAnalysisEmpty: boolean = false;
    public mapsAlreadyOpen: boolean = false;
    viewPinInfo: boolean = false;
    isFarmLabelVisible: boolean = false;

     isGriddingOptionslVisible: boolean = false;
     selectedAnalysisType: string = '';
     griddingColor: string = '';
     fieldColorMap: Map<number, string> = new Map();

    flex1: number = 20;
    flex2: number = 80;

    center = { lat: this.latitude, lng: this.longitude };

    public tenantId: number;
    public userId: number;

    public farmSubjects = new BehaviorSubject<Farm[]>(null);
    farms$ = this.farmSubjects.asObservable();

    public fieldSubjects = new BehaviorSubject<Field[]>(null);
    fields$ = this.fieldSubjects.asObservable();

    public historySubject = new BehaviorSubject<History[]>(null);
    histories$ = this.historySubject.asObservable();

    public histories: History[];
    public activeHistoryId;

    public geoJsonObject: Object[] = [];

    openedWindow: number = 0;
    public isTrackingActive = false;
    private trackingMarker;
    private watchId = -1;
    private location;

    public isLabelsShowing = true;
    public isPinLabelsShowing: boolean = true;

    public ndviHistories: History[];
    public niHistories: History[];
    public soilHistories: History[];

    private rainMeters: RainMeters[];

    activeId = -1;

    farmWidth: number;
    tenantView = true;

    tenantChanged = false;

    animationState = 'in';
    farmId = -1;
    farmName = "";
    public fieldCounter = -1;
    fieldId: number;
    startDate = moment().subtract(1, "months").format("YYYY-MM-DD");
    endDate = moment().format("YYYY-MM-DD");

    bounds: any = new google.maps.LatLngBounds();
    farmBounds: any;
    emptyLatLng: any;
    smallPolygon;
    unsortedPolygons = [];
    editablePolygons = [];
    newPolygons = [];
    editedPolygons = [];
    polygons = [];
    originalPolygons = [];
    editedOriginals = [];
    addedPolygons = [];
    polygonCoords = [];
    boundaryCenter;
    fieldBounds = [];
    polygonInteriors = [];

    showOptions = false;
    hideAnalysisLabel = false;

    selectedMapsItem: any;
    selectedFarmMapsItem: SelectedFarmMapsItemModel;

    selectedFarmMapsItemObj: any;

    analysisTypesAvailable: MapsTypesAvailabilityModel[] = [];
    selectedSatImage: any;
    selectedDate: any;

    editablePolygon: google.maps.Polygon;
    editableCircle: google.maps.Circle;
    circle;
    polygon;
    originalPolygon: google.maps.Polygon;

    mapsFarmImageryDto: MapsFarmImageryDto;

    images = [];
    image;
    overlay;
    overlayedAnalysis = [];
    fieldLegends: FieldLegend[] = [];
    farmLegends: FarmLegend[] = [];
    fieldLegends1: FieldLegend[] = [];
    aType

    opacity = 1.0;

    @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
    infoContent = '';

    markerLabelType: string = '';

    public iconUrl = {
        urlNewTemp: '../../assets/icons/new_pin_updated.png',
        urlMarker: '../../assets/icons/marker_pin.png',
        urlSoftVirualConsultant: '../../assets/icons/virtual_consultant_pin.png',
        urlSoftTissue: '../../assets/icons/soft_tissue_pin.png',
        urlSoil: '../../assets/icons/soil_pin.png',
        urlWater: '../../assets/icons/water_pin.png',
        urlDisease: '../../assets/icons/disease_pin.png',
        urlPest: '../../assets/icons/pest_pin.png',
        urlFertilizer: '../../assets/icons/fertilizer_pin.png',
        urlYieldEst: '../../assets/icons/yield_estimations_pin.png',
        urlNester: '../../assets/icons/Ntester_pin.png',
    }

    icon: google.maps.Icon = {
        url: this.iconUrl ? this.iconUrl.urlNewTemp : this.iconUrl.urlMarker,
        scaledSize: new google.maps.Size(24, 29)
    };
    markerOptions: google.maps.MarkerOptions = {
        icon: '#'
    };

    labelOptions = {
        color: 'white',
        fontFamily: '',
        fontSize: '14px',
        fontWeight: 'bold',
        text: ''
    }

    pinLabelOptions = {
        color: 'white',
        fontFamily: '',
        fontSize: '14px',
        fontWeight: 'bold',
        text: '',
    }


    pinMarker = {
        id: -1,
        position: { lat: -1, lng: -1 },
        title: '',
        farmName: '',
        label: this.pinLabelOptions,
        options: google.maps.MarkerOptions = {
            icon: google.maps.Icon = {
                url: this.icon,
                scaledSize: new google.maps.Size(24, 29)
            }
        }
    };


    fieldBoundaryColor: string = environment.google.mapConfig.polygonStrokeColour;
    fieldBoundaryEditColor: string = environment.google.mapConfig.polygonEditingStrokeColour;

    polygonOptions: google.maps.PolygonOptions = {
        strokeColor: this.fieldBoundaryColor,
        strokeWeight: 4,
        fillOpacity: 0.0
    }

    singlePolygon: google.maps.PolygonOptions = {
        strokeColor: this.fieldBoundaryColor,
        strokeWeight: 4,
        fillOpacity: 0.0
    }

    marker = new google.maps.Marker({
        id: -1,
        position: { lat: -1, lng: -1 },
        title: '',
        farmName: '',
        label: this.labelOptions
    });

    options: google.maps.MapOptions = {
        mapTypeControl: false,
        mapTypeId: 'hybrid',
        // mapTypeControlOptions: {
        //     position: google.maps.ControlPosition.TOP_CENTER,
        //     mapTypeIds: ['roadmap', 'satellite', 'hybrid','terrain']
        //   },
        zoomControl: true,
        minZoom: 4,
        scrollwheel: true,
        disableDoubleClickZoom: true,
        streetViewControl: false,
        restriction: {
            latLngBounds: {
                east: 170,
                north: 85,
                south: -85.05115,
                west: -170
            },
            strictBounds: true
        }
    }

    drawingManager: google.maps.drawing.DrawingManager;

    public tracking = "";
    public labels = "";
    public rainfall = "";
    public farm = "";
    public field = "";
    public edit = "";
    public closeEdit = "";
    public drawing = "";
    public busyEditing = "";
    public editingAll = "";
    public area = "";
    public closeAddField = "";

    public notifications: boolean = true;

    public isOpen: boolean = false;
    public isCurentlyOpen: boolean = false;
    selectedFarm: any;
    filteredFarms: Farm[];
    farms: Farm[];
    fields = [];
    fieldObject: { id: number, name: string } = { id: 0, name: '' };

    selectedAnalysis;
    analysisDates;

    countries: Countries[] = [];
    delete: boolean = false;
    noBoundary: boolean = false;

    loadingPins: boolean = false;

    saveFields: boolean = false;
    saveEditedField: boolean = false;
    saveArea: boolean = false;
    editing: boolean = false;
    editingFields: boolean = false;
    stillDrawing: boolean = false;
    changed: boolean = false;
    optionsReached: boolean = false;
    farmOptionsReached: boolean = false;
    oneAction: boolean = false;
    action: any = "";
    splitField: boolean = false;
    errorUpdating: boolean = false;
    splitFieldId;
    splitFieldName;
    fieldName = "";
    map;

    variance: number;
    polygonIsArray: boolean = false;
    polygonArray = [];
    subscription;

    constructor(
        public nav: NavBarComponent,
        public base: Base,
        public farmManagementService: FarmManagementService,
        public analysisManagementService: AnalysisManagementService,
        public rainfallService: RainfallService,
        public boundaryManagementService: BoundaryManagementService,
        public mappingService: MappingService,
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        private router: Router,
        public dialog: MatDialog,
        private _snackBar: MatSnackBar,
        private helper: HelperService,
        public translate: TranslateService,
        public pinManagerService: PinManagerService,
        public projectTitle: Title,
        private tenantService: TenantService,
        private tenantFarmBoundsService: TenantFarmBoundsService,
        private griddingStatusService: GriddingStatusService,
        private bottomSheet: MatBottomSheet,
        private weatherForecastService: WeatherForecastService,
        private featureFlagsService: FeatureFlagsService,

    ) {

        this.nav.toggleLoading(false);

        this.tracking = this.translate.instant("MAPPING.TRACKING");
        this.labels = this.translate.instant("MAPPING.LABELS");
        this.rainfall = this.translate.instant("MAPPING.RAINFALL");
        this.farm = this.translate.instant("MAPPING.ADD-FARM");
        this.field = this.translate.instant("MAPPING.ADD-FIELD");
        this.edit = this.translate.instant("MAPPING.EDIT-FIELDS");
        this.closeEdit = this.translate.instant("MAPPING.CLOSE-EDIT");
        this.drawing = this.translate.instant("MAPPING.DRAWING");
        this.busyEditing = this.translate.instant("MAPPING.EDITING");
        this.editingAll = this.translate.instant("MAPPING.EDITING-ALL");
        this.selectedAnalysis = this.translate.instant("HISTORY.FILTER-ALL");
        this.area = this.translate.instant("MAPPING.ADD-AREA");
        this.closeAddField = this.translate.instant("MAPPING.STOP-DRAWING");

        this.analysisDates = this.startDate + " " + this.translate.instant("HISTORY.FILTER-TO") + " " + this.endDate;

        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);

        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingControl: false,
        });

        this.drawingManager.setMap(null);

        if (this.mobileQuery.matches) {
            this.flex1 = 50;
            this.flex2 = 50;
        }

        this.userId = this.helper.getUserId();

        this.nav.tenantId$.subscribe(id => {
            if (id != null) {
                this.tenantView = true;
                this.tenantId = id;
                this.nav.toggleLoading(true);
                navigator.geolocation.clearWatch(this.watchId);
                this.markers.splice(this.markers.indexOf(this.trackingMarker), 1);
                this.geoJsonObject = [];
                this.markers = [];
                this.images = [];
                this.polygons = [];
            }
            this.zoomOutOnTenantChange();
        })

        this.base.fetchFarm().subscribe(farm => {

            this.zoom = this.minMapZoom;
            if (this.farmId == -1) {
                if (farm.farmId != null) {
                    this.farmId = farm.farmId;

                    this.farmName = farm.farmName;
                    this.base.fetchFilter().subscribe(filter);

                    this.tenantView = false;
                    this.farmManagementService.getFarmBoundingBox(farm.farmId).subscribe((boundingBox) => {

                        this.farmBounds = new google.maps.LatLngBounds();
                        this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
                        this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));
                    });
                }
            }
        });

          this.tenantFarmBoundsService.isTenantFarmLabelVisible = this.isFarmLabelVisible;
    }


    openWindow(id) {
        this.openedWindow = id;
    }

    // open close map-menu-circular
    openOptions() {
        this.isOpen = !this.isOpen;
    }


    navigateToSelectedFarm(id: number, farmName: string) {
        sessionStorage.setItem('lastFarmId', String(id));
        sessionStorage.setItem('lastFarmName', String(farmName));
        this.router.navigate(['/mapping']);
    }

    ngOnInit(): void {
        this.isWeatherForecastEnabled = this.featureFlagsService.isEnabled('weather_forecast_feature');
        this.hideAnalysisLabel = true;
        this.isFarmLabelVisible =  this.tenantFarmBoundsService.isTenantFarmLabelVisible;
        this.isOpen = false;
        this.nav.toggleLoading(true);
    }

    ngAfterViewInit() {
         this.tenantService.currenttenantId.subscribe(tenantId => {
            this.farmManagementService.getTenantFarmFields(this.tenantId).subscribe((result) => {
                this.tenantFarmFields = result;
                this.allBoundaryOverlay();
                this.setBounds();
            });
          });
    }

    allBoundaryOverlay() {
        let selectedTenantId = sessionStorage.getItem("selectedTenant");
        let farmSize = null;

        if(selectedTenantId === String(this.tenantId) && this.tenantFarmFields?.farms?.length > 0){
            console.log(this.tenantFarmFields)

            this.tenantFarmFields?.farms.forEach((farm) => {

            farmSize = Math.trunc(farm?.farmSize);

            farm?.fields.map((field) => {
                google.maps.event.addDomListener(window, "load");

                let  data = {                  
                        "type": "FeatureCollection",
                        "features": [
                            {
                            "type": "Feature",
                            "geometry": {
                                    "type": field?.fieldBoundary?.type, 
                                    "coordinates": field?.fieldBoundary?.coordinates 
                            },
                                "properties": {
                                    "tenantId": this.tenantFarmFields?.tenantId, 
                                    "tenantName": this.tenantFarmFields?.tenantName, 
                                    "farmId": farm?.farmId,
                                    "farmName": farm?.farmName, "farmSize": farmSize,
                                    "fieldId": field?.fieldId,
                                    "fieldName": field?.fieldName
                                }
                            }
                          ]   
                        }
            
                    this.tenantFarmBoundsService.googleMapData = data;
                    this.agmMap?.data?.addGeoJson(data);
                });
            })

            // Set style ONCE for all features AFTER adding all GeoJSON
            this.agmMap.data.setStyle((feature) => {
                let fillColor = "";
                let strokeColor = "";
                
                if (this.selectedAnalysisType === '' || this.selectedAnalysisType === null) {
                    fillColor = "#00000000";
                    strokeColor = environment.google.mapConfig.polygonStrokeColour;
                } else {
                    fillColor = "rgba(209, 19, 19, 0)";
                    const fieldId = feature.getProperty('fieldId') as number;
                    strokeColor = this.fieldColorMap.get(fieldId) || environment.google.mapConfig.griddingRedStrokeColour;
                }
                
                return {
                    fillColor: fillColor,
                    strokeColor: strokeColor,
                    strokeWeight: 4,
                };
            });

            const googleMapInstance = this.agmMap?.googleMap;

            googleMapInstance.data.addListener("mouseover", (event: google.maps.Data.MouseEvent) => {
                let latLng = event?.latLng;
                let color = this.polygonHoverColor;

                googleMapInstance.data.revertStyle();
                googleMapInstance.data.overrideStyle(event?.feature, { strokeWeight: 6, strokeColor: color });

                googleMapInstance.data.addListener("mouseout", () => {
                    if (this.currentInfoWindow) {
                        this.currentInfoWindow.close();
                        this.currentInfoWindow = null;
                    }
                    googleMapInstance.data.revertStyle();
                });
            })

            googleMapInstance.data.addListener("click", (event) => {
                let farmID = event?.feature.getProperty("farmId");
                let farmName = event?.feature.getProperty("farmName");
                this.navigateToSelectedFarm(farmID, farmName);
            });

            this.nav.toggleLoading(false);
            this.toggleFarmNameLabels();
            this.tenantFarmBoundsService.tenantFarmLabels = this.centerMarkers;
        } else {
            this.nav.toggleLoading(false);
            this.openSnackBar('There is no farm data for this tenant', this.translate.instant("SNACKBAR.DISMISS"));
        }
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
        });
    }


    setBounds() {
         this.tenantFarmBoundsService.googleMapComponent = this.agmMap; // Set map for service to use
        let markers = [];

            markers = [
                this.tenantFarmFields?.boundingBox?.coordinates
            ];

            const bounds = new google.maps.LatLngBounds();
            markers.forEach((marker) => {
                if(marker){
                    marker[0].forEach(([Lat, Lng]) => {
                    bounds.extend(new google.maps.LatLng(Lng, Lat)); //Swap here due to GeoJson swapping coordinates as default
                })
                }

            });
                if(bounds){
                    this.tenantFarmBoundsService.bounds = bounds;
                    this.agmMap?.fitBounds(bounds);
                }
         }


    toggleFarmNameLabels() {

        this.isFarmLabelVisible = !this.isFarmLabelVisible;

        let marker = null;
        const map = this.agmMap?.googleMap;

            this.tenantFarmFields?.farms.forEach((farm) => {
                if (this.isFarmLabelVisible) {
                    const centerMarker: google.maps.LatLngLiteral = {
                        lat: farm.centroidLat,
                        lng: farm.centroidLng
                    }

                    if (this.agmMap) {
                        marker = new google.maps.Marker({
                            position: centerMarker,
                            title: farm.farmName || '',
                            map: map,
                            label: {
                                color: 'white',
                                fontFamily: '',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                text: farm.farmName
                            },
                            options: google.maps.MarkerOptions = {
                                icon: google.maps.Icon = {
                                    url: '#',
                                }
                            },
                            type: 'labelPin'
                        });

                    }
                    this.centerMarkers.push(marker);

                } else if (!this.isFarmLabelVisible) {
                    this.centerMarkers.forEach(marker => marker.setMap(null));
                    this.centerMarkers = [];
                }
     
                this.tenantFarmBoundsService.clearFarmNameLabels();
            });

          this.isOpen = false;
    }

    zoomOutOnTenantChange() {
        this.nav.toggleLoading(true);

    if(this.router.url === '/tenant-view'){
        this.tenantFarmBoundsService.clearTeanatviewMap();
    }
         this.setBounds();
         this.isFarmLabelVisible = true;
        this.toggleFarmNameLabels();

        setTimeout(() => {
            this.nav.toggleLoading(false);
        }, 4000);
    }


    showGriddingOptions(){

    const dialogConfig = new MatDialogConfig();
          dialogConfig.height = '96vh';
    dialogConfig.data = {
      tenantId: this.tenantId,
    };
        this.isGriddingOptionslVisible = true;

        const dialogRef = this.dialog.open(GriddingComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(response => {
             this.isOpen = false;
        });
       
    }

    showWeatherForecast() {
        const lat = this.center.lat;
        const lng = this.center.lng;
        
        const bottomSheetRef = this.bottomSheet.open(WeatherForecastComponent, {
            data: { isLoading: true, forecasts: [] }
        });

        bottomSheetRef.instance.isLoading = true;
        
        this.weatherForecastService.getWeatherForecast(lat, lng).subscribe({
            next: (forecasts) => {
                bottomSheetRef.instance.forecasts = forecasts;
                bottomSheetRef.instance.isLoading = false;
            },
            error: () => {
                bottomSheetRef.dismiss();
                this.openSnackBar('Failed to load weather forecast', this.translate.instant("SNACKBAR.DISMISS"));
            }
        });
    }
}
